<script>
import CheckboxField from '@phoenix/mixins/components/form/fields/CheckboxField';
import { useField } from '@phoenix/composables/field';

export default {
  mixins: [CheckboxField],

  props: {
    modelValue: {
      type: [Boolean, Array],
      default: false,
    },
    extraClasses: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    return useField(props);
  },

  computed: {
    checkboxClasses() {
      return ['switch switch--checkbox', this.extraClasses, { 'switch--error': this.isInvalid }];
    },

    labelClasses() {
      return ['input-label switch__label checkbox-label', { 'input-label--error': this.isInvalid }];
    },

    inputValue() {
      return Array.isArray(this.value) ? this.field.value : null;
    },
  },
};
</script>

<template>
  <div :class="checkboxClasses">
    <label :for="fieldUniqueId" :class="labelClasses">
      <slot name="label">
        <span class="input-label__text" v-html="field.label" />
      </slot>
    </label>

    <input
      :id="fieldUniqueId"
      v-model="value"
      :value="inputValue"
      :name="field.name"
      :data-cy="field.dataCy"
      :aria-describedby="ariaDescribedby"
      type="checkbox"
      class="switch__input"
    />
  </div>
</template>
